import { atom } from "jotai";

// NOTE: atom 자체는 일단 ko/en만 담는다. 기존 호출부(`xxxLocale.foo[locale.locale]`)가
// `{ ko, en }` 객체 인덱서로 좁혀져 있어, 본 타입을 SupportedLanguage로 넓히면
// 호출부 전체가 codemod 적용(§3) 전까지 TS 에러가 발생한다. 호출부 마이그레이션이
// 끝난 §5(정리) 단계에서 SupportedLanguage 로 교체한다.
export type Locale = { locale: "ko" | "en" };

export const locale = atom<Locale>({
  locale: "ko",
});
